<div class="container-fluid">
  <h1>
    {{ 'revenue.class-type.class-type' | translate | titlecase }}
  </h1>

  <p>
    <button app-add-button [label]="'revenue.class-type.add-button-label' | translate | titlecase" (onClick)="newClassType()"> </button>
  </p>

  <p [hidden]="!loadingClassTypes"><wl-busy [show]="loadingClassTypes"></wl-busy> {{ 'common.loading' | translate | titlecase }}...</p>

  <p [hidden]="loadingClassTypes || classTypes?.length">
    {{ 'revenue.class-type.no-class-types' | translate | titlecase }}
  </p>

  <p-table [showGridlines]="true"
    #classTypeDataGrid
    class="col-md-6"
    [lazy]="true"
    [rows]="10"
    [value]="classTypes"
    [paginator]="true"
    (onLazyLoad)="lazyLoadClassTypes($event)"
    [totalRecords]="searchResult.TotalCount"
    [hidden]="loadingClassTypes || !classTypes?.length"
  >
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="ClassType">
          {{ 'revenue.class-type.class-type' | translate | titlecase }}
          <p-sortIcon field="ClassType"></p-sortIcon>
        </th>
        <th pSortableColumn="Descr">
          {{ 'revenue.class-type.descr' | translate | titlecase }}
          <p-sortIcon field="Descr"></p-sortIcon>
        </th>
        <th style="width: 140px"></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-type>
      <tr>
        <td>{{ type.ClassType }}</td>
        <td>{{ type.Descr }}</td>
        <td>
          <div class="btn-group mct-gap-5">
            <button pButton type="button" class="btn btn-default" (click)="editClassType(type.ClassTypeId)" icon="pi pi-pencil"></button>
            <button
              pButton
              type="button"
              class="btn btn-danger"
              (click)="type._canDelete = false; confirmDeleteClassType(type.ClassTypeId)"
              [disabled]="!type._canDelete"
              icon="pi pi-trash"
            ></button>
            <p-checkbox binary="true" [(ngModel)]="type._canDelete" pTooltip="Check to enable delete" tooltipPosition="top"> </p-checkbox>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <p-progressSpinner *ngIf="isSearching"></p-progressSpinner>
</div>

<p-dialog
  modal="true"
  #classTypeModal
  [(visible)]="showClassTypeModal"
  [closable]="true"
  styleClass="atlas-dialog-l"
  [focusOnShow]="false"
  [contentStyle]="{ 'max-height': '75vh' }"
>
  <ng-template pTemplate="header">
    <h4 class="modal-title">{{ 'revenue.class-type.class-type' | translate | titlecase }}</h4>
  </ng-template>

  <form novalidate #classTypeForm="ngForm">
    <p *ngIf="loadingClassType.busy">
      <wl-busy [show]="loadingClassType.busy"></wl-busy>
    </p>

    <div class="alert alert-danger" *ngIf="loadingClassType.message && !loadingClassType.success">
      {{ loadingClassType.message }}
    </div>

    <div class="alert alert-danger" *ngIf="classTypeField.invalid && classTypeField.touched">
      {{ 'revenue.class-type.no-class-type-error' | translate }}
    </div>

    <div class="container-fluid" [hidden]="loadingClassType.busy">
      <div class="form-horizontal">
        <div class="form-group">
          <label class="col-sm-3 control-label">
            {{ 'revenue.class-type.class-type' | translate | titlecase }}
          </label>
          <div class="col-sm-9">
            <input
              pattern="^\w(?:.*?\w$)?"
              [disabled]="editing"
              name="class-type"
              #classTypeField="ngModel"
              class="form-control"
              type="text"
              [(ngModel)]="selectedClassType.ClassType"
              required
            />
          </div>
        </div>
        <div class="form-group">
          <label class="col-sm-3 control-label">
            {{ 'revenue.class-type.descr' | translate | titlecase }}
          </label>
          <div class="col-sm-9">
            <input class="form-control" name="descr" type="text" [(ngModel)]="selectedClassType.Descr" />
          </div>
        </div>
      </div>
    </div>
  </form>

  <ng-template pTemplate="footer">
    <div class="alert alert-danger" [hidden]="!savingError">
      {{ savingError }}
    </div>
    <div class="mct-flex mct-row mct-justify-end mct-items-center mct-gap-10">
      <wl-busy [show]="saving"></wl-busy>
      <button
        pButton
        type="button"
        class="btn btn-primary"
        (click)="editing = false; saveClassTypes()"
        [disabled]="classTypeForm.invalid || saving"
        icon="pi pi-save"
        [label]="(saving ? 'common.saving' : 'common.save') | translate | titlecase"
      ></button>
      <button
        pButton
        type="button"
        class="btn btn-secondary"
        (click)="editing = false; showClassTypeModal = false"
        [disabled]="saving"
        icon="pi pi-ban"
        [label]="'common.cancel' | translate | titlecase"
      ></button>
    </div>
  </ng-template>
</p-dialog>

<p-dialog
  #confirmDeleteClassTypeModal
  modal="true"
  [(visible)]="showDeleteModal"
  [closable]="false"
  styleClass="atlas-dialog-l"
  [focusOnShow]="false"
  [contentStyle]="{ 'max-height': '75vh' }"
>
  <div class="p-3 text-center">
    <i class="pi pi-exclamation-triangle mr-2" style="font-size: 2rem; color: var(--red-500)"></i>
    <span>{{ 'revenue.class-type.delete-confirm' | translate }}</span>
  </div>

  <ng-template pTemplate="footer">
    <div class="alert alert-danger" [hidden]="!deleteError">
      {{ deleteError }}
    </div>
    <div class="mct-flex mct-row mct-justify-end mct-items-center mct-gap-10">
      <wl-busy [show]="deleting"></wl-busy>
      <button
        pButton
        type="button"
        class="btn btn-danger"
        (click)="deleteClassType()"
        [disabled]="deleting"
        icon="pi pi-trash"
        [label]="(deleting ? 'common.deleting' : 'common.delete') | translate | titlecase"
      ></button>
      <button
        pButton
        type="button"
        class="btn btn-secondary"
        (click)="showDeleteModal = false"
        [disabled]="deleting"
        icon="pi pi-ban"
        [label]="'common.cancel' | translate | titlecase"
      ></button>
    </div>
  </ng-template>
</p-dialog>
